import { selector } from 'recoil';
import { jobIdAtom } from '../atoms/jobIdAtom';
import { opcInfoAtom } from '../atoms/opcInfoAtom';
import { onsaInfoAtom } from '../atoms/onsaInfoAtom';
import { type BusinessFlow } from '../types/types';
import { resumeOnsaAtom } from '../atoms/resumeOnsaAtom';
import { mpsActivationInfoAtom } from '../atoms/mpsActivationInfoAtom';

export const businessFlowSelector = selector<BusinessFlow>({
    key: 'businessFlowSelector',
    get: ({ get }) => {
        const isOpc = get(opcInfoAtom).tilpas;
        const onsaInfo = get(onsaInfoAtom);
        const resumeOnsa = get(resumeOnsaAtom);
        const { jobNumber } = resumeOnsa;
        const isOnsa = onsaInfo.onsaStep ?? onsaInfo.flavourName ?? jobNumber;
        const isDa = get(jobIdAtom);
        const isMps = get(mpsActivationInfoAtom).policeNummer;

        if (isMps) {
            return 'MPS';
        } else if (isOnsa) {
            return 'ONSA';
        } else if (isDa) {
            return 'DA';
        } else if (isOpc) {
            return 'OPC';
        }
    }
});
